export const donateDeepColor = "#e73650";
export const shareColor = "#ffa44e";
